import React from 'react';
import { useAddEmployeeMutation } from '@/redux';
import { useAppFindFormik } from '@/components';
import { AddEmployeeDto, ProjectDto } from '@/core';
import { EmployeeForm } from './EmployeeForm';
import { FormValueType } from './hooks';
import { handleEmployeeData } from './helpers';

const getInitialValue = (): FormValueType => ({
  name: '',
  positionId: null,
  department: null,
});

type PropsType = {
  projectData: ProjectDto;
};

export const ProjectsAddEmployeeForm = ({ projectData }: PropsType) => {
  const form = useAppFindFormik('add-employee');
  const [addEmployee] = useAddEmployeeMutation();
  const initialValue = getInitialValue();

  const handleSubmit = (employeeData: AddEmployeeDto) => {
    const handledEmployeeData = handleEmployeeData(employeeData);

    addEmployee({ employeeData: handledEmployeeData, projectId: projectData.id })
      .unwrap()
      .then(() => form.current?.resetForm());
  };

  return (
    <EmployeeForm
      handleSubmit={handleSubmit}
      projectData={projectData}
      formUid="add-employee"
      initialValue={initialValue}
      isTooltip
    />
  );
};
